
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/member-benefits",
      function () {
        return require("private-next-pages/loyalty/member-benefits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/member-benefits"])
      });
    }
  